import React, {useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import './Talent.css';

import Header from '../../sections/Header/Header'
import Footer from '../../sections/Footer/Footer';
import PreviewSlider from '../../components/Slider/PhotoSlider/PhotoSlider';

import Splash1 from '../../../tmp/splash1.jpg';
import photoGirl1 from '../../../tmp/sara1.jpg';
import photoGirl2 from '../../../tmp/veronika1.jpg';
import photoGirl3 from '../../../tmp/kristina1.jpg';

const Talent = () => {

    const navigate = useNavigate();

    const {city} = useParams();

    const tempPreviewImages = [
        photoGirl1,
        photoGirl2,
        photoGirl3,
    ];

    const tempPreviewImages2 = [
        Splash1,
        photoGirl2,
        photoGirl3,
    ]

    const tempPreviewImages3 = [
        photoGirl2,
        Splash1,
        photoGirl3,
    ]

    const tempPreviewImages4 = [
        photoGirl3,
        photoGirl2,
        Splash1,
    ]

    const handleCityChange = (e) => {
        const value = e.currentTarget.value;
        navigate(value);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <>
            <Header />
            <section className="section-header">
                <div className="view-container">
                    <h1>Talent <span>{city}</span></h1>
                    <p>Our agency represents the best talent in the industry, offering a diverse roster of top-tier performers who 
                        consistently deliver exceptional results.</p>
                    <div className="city-selector">
                        <span>City:</span><select onChange={handleCityChange}>
                            <option value="/talent">All</option>
                            <option value="/talent/rome">Rome</option>
                            <option value="/talent/milan">Milan</option>
                        </select>
                    </div>
                </div>
            </section>
            <section className="talent-wall talent-page">
                {
                    city === 'milan' ? 
                        <>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                                <PreviewSlider col={4} images={tempPreviewImages} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                                <PreviewSlider col={4} images={tempPreviewImages3} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                        </> : 

                        city === 'rome' ? 
                        <>
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                        </> :

                        <>
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages3} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages3} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                            <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                            <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                            <PreviewSlider col={4} images={tempPreviewImages3} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                            <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
                        </>
                }
                
            </section>
            <Footer />
        </>
    )


}

export default Talent;